import { AppointmentType, Clinic } from 'kb-shared/types';

import { containsOnlyVirtualAppointmentType } from './validation';
import { StepType } from '../types/types';

export const shouldSkipLocationStep = ({
  step,
  selectedAppointmentTypes,
  selectedClinic,
  partnerClinicSearch,
  inClinicTimeSlotsExist,
  virtualOnlyMarket = false
}: {
  step: StepType;
  selectedAppointmentTypes: Array<AppointmentType>;
  selectedClinic: Clinic | undefined;
  partnerClinicSearch: string;
  inClinicTimeSlotsExist: boolean;
  virtualOnlyMarket?: boolean;
}): boolean => {
  if (partnerClinicSearch === 'search') return false;

  // Closed markets are left out of the location step's market list, so go straight to the
  // virtual-only time picker.
  if (step === 'location' && virtualOnlyMarket) return true;

  if (
    (step === 'location' &&
      (containsOnlyVirtualAppointmentType(selectedAppointmentTypes ?? []) || selectedClinic)) ||
    !inClinicTimeSlotsExist
  ) {
    return true;
  }

  return false;
};
